import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { PerfilRiesgoEstado } from '../_models/perfil-riesgo-estado';

@Injectable({
  providedIn: 'root'
})
export class PerfilRiesgoEstadoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/perfilesRiesgosEstados';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PerfilRiesgoEstado[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PerfilRiesgoEstado[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PerfilRiesgoEstado ) );
  }

  obtenerPorPerfilRiesgo( id: string ) {
    return this.httClient.get( this.rutServicio + '/perfilRiesgo/' + id ).pipe( map( res => res as PerfilRiesgoEstado ) );
  }

  crear( regCrear: PerfilRiesgoEstado ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PerfilRiesgoEstado ) );
  }

  actualizar( regActualizar: PerfilRiesgoEstado ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
